import { matchPath } from 'react-router';
import nextRoutes from '../nextRoutes';

// Function to check if a route has been migrated.
const hasMigrated = to => {
  for (let i = 0; i < nextRoutes.length; i++) {
    const route = nextRoutes[i];
    const [toMatch] = to?.split('?') || ['/'];
    const match = matchPath(toMatch, route);
    if (match && match.path && match.url) {
      return true;
    }
  }
  return false;
};

export default hasMigrated;
